<template>
  <div class="content">
    <div>
      <div class="md-layout-item md-size-100 text-right">
        <br>
        <br>
<!--        <md-button class="md-raised md-success mr-4">Add</md-button>-->
      </div>
    </div>
    <div class="md-layout w-100">
      <router-link to="/admin/blogs" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>comment</md-icon>
          </template>
          <template slot="content">
            <h3 class="title">All posts</h3>
          </template>
          <template slot="footer">
            <div class="stats">
              <md-icon>comment</md-icon>
              {{admin_data.blogs_count}} Posts
            </div>
          </template>
        </stats-card>
      </router-link>
      <router-link to="/admin/reviews" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>reviews</md-icon>
          </template>
          <template slot="content">
            <h3 class="title">All reviews</h3>
          </template>
          <template slot="footer">
            <div class="stats">
              <md-icon>reviews</md-icon>
              {{admin_data.reviews_count}} Reviews
            </div>
          </template>
        </stats-card>
      </router-link>
      <router-link to="/admin/contacts" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="red">
          <template slot="header">
            <md-icon>group</md-icon>
          </template>
          <template slot="content">
            <h3 class="title">All contacts </h3>
          </template>
          <template slot="footer">
            <div class="stats">
              <md-icon>group</md-icon>
              {{admin_data.contacts_count}} Contacts
            </div>
          </template>
        </stats-card>
      </router-link>
      <router-link to="/admin/blocked_contacts" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>person_off</md-icon>
          </template>
          <template slot="content">
            <h3 class="title">Blocked</h3>
          </template>
          <template slot="footer">
            <div class="stats">
              <md-icon>person_off</md-icon>
              {{admin_data.blocked_mails_count}} Contacts
            </div>
          </template>
        </stats-card>
      </router-link>
      <!--        <md-icon>home</md-icon>-->
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {StatsCard} from "@/components";

export default {
  name: "MainAdmin",
  data() {
    return {
      admin_data: []
    }
  },
  components: {
    StatsCard
  },
  created() {
    this.getDataCount()
  },
  methods: {
    ...mapActions(['getAdminData']),
    getDataCount() {
      this.getAdminData()
      .then(res => {
        this.admin_data = res.data
      })
    }

  }
}
</script>

<style scoped lang="scss">

</style>
